(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function start(el) {
      if (el.dataset.started) return;
      el.dataset.started = 'true';
      var end = new Date(el.dataset.end).getTime();
      if (isNaN(end)) {
        el.hidden = true;
        return;
      }
      var parts = {
        d: el.querySelector('[data-unit="d"]'),
        h: el.querySelector('[data-unit="h"]'),
        m: el.querySelector('[data-unit="m"]'),
        s: el.querySelector('[data-unit="s"]')
      };

      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }
        var total = Math.floor(diff / 1000);
        parts.d.textContent = pad(Math.floor(total / 86400));
        parts.h.textContent = pad(Math.floor((total % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((total % 3600) / 60));
        parts.s.textContent = pad(total % 60);
      }

      var timer = setInterval(tick, 1000);
      tick();
    }

    function init() {
      document.querySelectorAll('.countdown-timer').forEach(start);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
